import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MarkdownPipe } from '@base/pipe/btl-markdown.pipe';

import { WithoutTaxPipe } from '@app/baseBtl/base/pipes/withoutTax.pipe';
import { ViewBladesComponent } from '@app/catalog/products/view/tabs/view-plans/view-blades/view-blades.component';

import {
    BreadCrumbModule,
    ButtonModule,
    CarouselModule,
    CountdownModule,
    ModalModule,
    PriceModule,
    SliderModule,
    ToggleModule,
} from '@trilogy';

import { StepperComponent } from '../baseBtl/base/components/stepper/stepper.component';
import { CustomCurrencyPipe } from '../baseBtl/base/pipes/currency.pipe';
import { FilterPipe } from '../baseBtl/base/pipes/filter.pipe';
import { FilterObjPipe } from '../baseBtl/base/pipes/filterObj.pipe';
import { KeysPipe } from '../baseBtl/base/pipes/keyValues.pipe';
import { OrderAttributesPipe } from '../baseBtl/base/pipes/orderAttributes.pipe';
import { OrderObjPipe } from '../baseBtl/base/pipes/orderObj.pipe';
import { BladeDetailsComponent } from '../catalog/category/plans/blade-details/blade-details.component';
import { BreadcrumbComponent } from './components/breadcumb/breadcrumb.component';
import { BtlPriceComponent } from './components/btl-price/btl-price.component';
import { ErrorsListComponent } from './components/errors-list/errors-list.component';
import { PreFooterComponent } from './components/pre-footer/pre-footer.component';
import { StructuredDataComponent } from './components/structured-data/structured-data.component';
import { FlickitySliderDirective } from './directives/flickity-slider.directive';
import { FullscreenClassToggleDirective } from './directives/fullscreen-class-toggle.directive';
import { HideOnScrollDirective } from './directives/hide-on-scroll.directive';
import { ScrollIntoViewOnClickDirective } from './directives/scroll-into-view-on-click.directive';
import { ScrollPointTargetDirective } from './directives/scroll-point-target.directive';
import { ScrollToDirective } from './directives/scroll-to.directive';
import { ScrollDirective } from './directives/scroll.directive';
import { StickyDirective } from './directives/sticky.directive';
import { I18n } from './services/i18n.service';
import { SharedForAllModule } from './shared-for-all.module';

@NgModule({
    imports: [
        CommonModule,
        CarouselModule,
        PriceModule,
        ModalModule,
        ButtonModule,
        SliderModule,
        FormsModule,
        SharedForAllModule,
        CountdownModule,
        BreadCrumbModule,
        ToggleModule,
    ],
    declarations: [
        FlickitySliderDirective,
        StickyDirective,
        ScrollPointTargetDirective,
        FullscreenClassToggleDirective,
        CustomCurrencyPipe,
        StepperComponent,
        FilterObjPipe,
        KeysPipe,
        OrderObjPipe,
        OrderAttributesPipe,
        FilterPipe,
        WithoutTaxPipe,
        HideOnScrollDirective,
        ScrollDirective,
        BtlPriceComponent,
        ErrorsListComponent,
        ScrollIntoViewOnClickDirective,
        ScrollToDirective,
        BladeDetailsComponent,
        ViewBladesComponent,
        BreadcrumbComponent,
        PreFooterComponent,
        StructuredDataComponent,
        MarkdownPipe,
    ],
    providers: [FilterObjPipe, I18n],
    exports: [
        FlickitySliderDirective,
        FullscreenClassToggleDirective,
        ScrollIntoViewOnClickDirective,
        ScrollToDirective,
        StickyDirective,
        ScrollPointTargetDirective,
        CustomCurrencyPipe,
        StepperComponent,
        FilterObjPipe,
        KeysPipe,
        OrderObjPipe,
        OrderAttributesPipe,
        FilterPipe,
        WithoutTaxPipe,
        HideOnScrollDirective,
        ScrollDirective,
        BtlPriceComponent,
        ErrorsListComponent,
        BladeDetailsComponent,
        BreadcrumbComponent,
        PreFooterComponent,
        StructuredDataComponent,
        SharedForAllModule,
        MarkdownPipe,
    ],
})
export class BaseModule {}
